import AffiliteHero from '@components/affiliate/AffiliteHero';
import AffiliteInfo from '@components/affiliate/AffiliteInfo';
import AffiliteReview from '@components/affiliate/AffiliteReview';
import HomepageSEO from '@components/common/SEO/HomepageSEO';
import ErrorBoundary from '@components/ErrorBoundary';
import HeaderWithCTA from '@components/header-with-cta';
import PricingPlan from '@components/pricing-plan';
import SuperbVideoCTA from '@components/superb-videos-cta';
import Testimonials from '@components/testimonials/Index';
import { footerExploreLinks } from '@constants/footerExplore';
import { HOMEPAGE } from '@constants/homepage';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import Footer from '@invideoio/web-shared/components/Footer';
import { StateContext } from '@store/store';
import useTranslation from 'next-translate/useTranslation';
import React, { useContext } from 'react';
import AppLayout from './AppLayout';
import dynamic from 'next/dynamic';

const AppPromo = dynamic(
  () =>
    import(
      /* webpackChunkName: "AppPromo" */
      '@components/app-promo'
    ),
);

function AffiliateLandingPage(props: any) {
  const { seo, pageData } = props;

  const globalState = useContext(StateContext);
  const { platform, os, config, browser } = globalState;

  const { t, lang } = useTranslation('home');

  return (
    <AppLayout platform={platform}>
      <HomepageSEO seo={seo} />

      <HeaderWithCTA />

      <ErrorBoundary>
        <AffiliteHero heroSection={pageData.mainSection} platform={platform} />
      </ErrorBoundary>

      <ErrorBoundary>
        <AffiliteInfo infoSection={pageData.section2} />
      </ErrorBoundary>

      <ErrorBoundary>
        <AffiliteReview
          reviewSection={pageData.section3}
          name={pageData.mainSection.name}
        />
      </ErrorBoundary>

      <div
        className={ivclass(
          'iv-bg-grey-100',
          'xl:iv-mt-200 iv-mt-150 sm:iv-mt-100',
          'xl:iv-mb-[-10px] lg:iv-mb-[-10px]',
        )}
      >
        <div className={ivclass('xl:iv-container xl:iv-mx-auto')}>
          <ErrorBoundary>
            <PricingPlan platform={platform as PlatformType} />
          </ErrorBoundary>
        </div>
      </div>
      <Testimonials
        platform={platform}
        siteName={globalState.config?.site?.name}
      />
      <div className={ivclass('xl:iv-container xl:iv-mx-auto')}>
        <AppPromo os={os} isNotDesktop={platform !== 'desktop'} />
      </div>
      <SuperbVideoCTA
        heading={{
          plainHeading: t(`superbVideo.heading.plainHeading`),
          highlightedHeading: t(`superbVideo.heading.highlightedHeading`),
        }}
        buttonText={t(`superbVideo.buttonText`)}
        CTAUrl={HOMEPAGE.superbVideo.CTAUrl}
      />
      <Footer
        os={os}
        platform={platform}
        socialLinks={globalState.socialLinks}
        exploreLinks={footerExploreLinks[config?.env?.siteId][lang].links}
      />
    </AppLayout>
  );
}

export default AffiliateLandingPage;
